module.exports = __webpack_public_path__ + "img/009.0975060f.png";